// ============================================================
// PALETTE VISUELLE DES AVATARS (DÉTERMINISTE PAR BOUTIQUE)
// ============================================================
export const SHOP_PALETTES = [
  {
    bg: 'bg-emerald-100 dark:bg-emerald-950/60',
    text: 'text-emerald-800 dark:text-emerald-300',
    border: 'border-emerald-300 dark:border-emerald-700/50',
    dot: 'bg-emerald-500',
  },
  {
    bg: 'bg-indigo-100 dark:bg-indigo-950/60',
    text: 'text-indigo-800 dark:text-indigo-300',
    border: 'border-indigo-300 dark:border-indigo-700/50',
    dot: 'bg-indigo-500',
  },
  {
    bg: 'bg-amber-100 dark:bg-amber-950/60',
    text: 'text-amber-900 dark:text-amber-300',
    border: 'border-amber-300 dark:border-amber-700/50',
    dot: 'bg-amber-500',
  },
  {
    bg: 'bg-sky-100 dark:bg-sky-950/60',
    text: 'text-sky-800 dark:text-sky-300',
    border: 'border-sky-300 dark:border-sky-700/50',
    dot: 'bg-sky-500',
  },
  {
    bg: 'bg-violet-100 dark:bg-violet-950/60',
    text: 'text-violet-800 dark:text-violet-300',
    border: 'border-violet-300 dark:border-violet-700/50',
    dot: 'bg-violet-500',
  },
  {
    bg: 'bg-rose-100 dark:bg-rose-950/60',
    text: 'text-rose-800 dark:text-rose-300',
    border: 'border-rose-300 dark:border-rose-700/50',
    dot: 'bg-rose-500',
  },
  {
    bg: 'bg-teal-100 dark:bg-teal-950/60',
    text: 'text-teal-800 dark:text-teal-300',
    border: 'border-teal-300 dark:border-teal-700/50',
    dot: 'bg-teal-500',
  },
  {
    bg: 'bg-fuchsia-100 dark:bg-fuchsia-950/60',
    text: 'text-fuchsia-800 dark:text-fuchsia-300',
    border: 'border-fuchsia-300 dark:border-fuchsia-700/50',
    dot: 'bg-fuchsia-500',
  },
] as const;

export const SHOP_SOLID_PALETTES = [
  { bg: 'bg-emerald-600', text: 'text-white' },
  { bg: 'bg-indigo-600', text: 'text-white' },
  { bg: 'bg-amber-600', text: 'text-white' },
  { bg: 'bg-sky-600', text: 'text-white' },
  { bg: 'bg-violet-600', text: 'text-white' },
  { bg: 'bg-rose-600', text: 'text-white' },
  { bg: 'bg-teal-600', text: 'text-white' },
  { bg: 'bg-fuchsia-600', text: 'text-white' },
] as const;

export function getShopSolidColor(identifier: string) {
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = (hash << 5) - hash + identifier.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % SHOP_SOLID_PALETTES.length;
  return SHOP_SOLID_PALETTES[index] ?? { bg: 'bg-emerald-600', text: 'text-white' };
}

export function getShopColorPalette(identifier: string) {
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = (hash << 5) - hash + identifier.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % SHOP_PALETTES.length;
  const palette = SHOP_PALETTES[index];
  return (
    palette ?? {
      bg: 'bg-emerald-100 dark:bg-emerald-950/60',
      text: 'text-emerald-800 dark:text-emerald-300',
      border: 'border-emerald-300 dark:border-emerald-700/50',
      dot: 'bg-emerald-500',
    }
  );
}

export function initials(name?: string | null): string {
  if (!name) return 'V';
  const parts = name.trim().split(/\s+/);
  const first = parts[0];
  if (!first) return 'V';
  if (parts.length === 1) return first.slice(0, 2).toUpperCase();
  const second = parts[1] ?? '';
  return `${first[0] ?? ''}${second[0] ?? ''}`.toUpperCase() || 'V';
}

export function formatRole(role?: string | null): string | null {
  if (!role) return null;
  const normalized = role.toLowerCase().trim();
  switch (normalized) {
    case 'owner':
      return 'Propriétaire';
    case 'manager':
      return 'Gérant';
    case 'cashier':
      return 'Caissier';
    case 'seller':
      return 'Vendeur';
    case 'accountant':
      return 'Comptable';
    default:
      return role.charAt(0).toUpperCase() + role.slice(1);
  }
}
